export const PRIVILEGE_KIND_VIEW = 'V';
export const PRIVILEGE_KIND_EDIT = 'E';
export const PRIVILEGE_KIND_ADD =   'A';
export const PRIVILEGE_KIND_DELETE = 'D';

export const PRIVILEGE_SYSTEMUSERS =                'SYSTEMUSERS';
export const PRIVILEGE_SYSTEMUSER_PRIVILEGES =      'SYSTEMUSERS_PRIVILEGES';
export const PRIVILEGE_SYSTEMUSER_PASSWORD_RESET =  'SYSTEMUSERS_PASSWORD_RESET';

export const PRIVILEGE_POLLS = 'POLLS';